import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ITrackPackageResponse } from '../../models/trackPage/trackPackage.model';

interface IInitialState {
  trackPackage?: ITrackPackageResponse;
}
const initialState: IInitialState = {
  trackPackage: undefined,
};

const trackPackageSlice = createSlice({
  name: 'trackPackage',
  initialState,
  reducers: {
    setTrackPackage(state, action: PayloadAction<IInitialState>) {
      state.trackPackage = action.payload.trackPackage;
    },
  },
});

export const trackPackageActions = trackPackageSlice.actions;
export default trackPackageSlice.reducer;
